import styled from 'styled-components/macro'

export const Container = styled.div`
  width: 100%;
  height: fit-content;
  position: relative;
  margin-top: 30px;
  margin-bottom: 30px;
`
export const ContainerContent = styled.div`
  display: flex;
  margin-top: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  width: fit-content;
`
export const DriversImg = styled.img`
  cursor: pointer;
`
export const DriversTitle = styled.h3`
  font-family: 'L10';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  /* identical to box height, or 100% */

  letter-spacing: 0.0714286px;
`
export const DriversContent = styled.span`
  cursor: pointer;
  margin-left: 16px;
  font-family: 'L10';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  /* identical to box height, or 154% */
`
